import React from "react";
import ErrorManager from "../util/ErrorManager";
import ValhallaApi from "../api/ValhallaApi";
import SafeFunApi from "../api/SafeFunApi";
import IdentityApi from "../api/IdentityApi";
import IdentityUserApi from "../api/IdentityUserApi";
import * as QueryString from "query-string";
import { Redirect } from "react-router-dom";
import { Paths } from "../Constants";

class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this.auth = null;
    this.errorManager = new ErrorManager();
    this.valhallaApi = new ValhallaApi();
    this.safeFunApi = new SafeFunApi();
    this.identityApi = new IdentityApi();
    this.identityUserApi = new IdentityUserApi();
    this.params = null;
    if (props && props.location) {
      this.params = QueryString.parse(props.location.search);
    }
    this.setStateValue = this.setStateValue.bind(this);
    this.getParameter = this.getParameter.bind(this);
  }

  getParameter(param) {
    if (!this.props.route.params) {
      return null;
    }
    if (!this.props.route.params[param]) {
      return null;
    }
    return this.props.route.params[param];
  }

  setStateValue(name, value) {
    this.setState({ ...this.state, [name]: value });
  }

  async checkLogin() {
    if (await this.identityApi.isUserLoginExpired()) {
      this.redirect(Paths.LOGIN);
      return false;
    }
    return true;
  }

  async redirect(pageName, search, state) {
    this.setState({
      redirectPath: pageName,
      redirectSearch: search,
      redirectState: state,
    });
  }

  render() {
    return this.state.redirectPath ? (
      <Redirect
        to={{
          pathname: this.state.redirectPath,
          search: this.state.redirectSearch,
          state: this.state.redirectState,
        }}
      />
    ) : null;
  }
}

export default BaseComponent;
